<template>
  <div class="participate" v-if="!isLoading">
    <button class="participate-button" @click.stop="handleOpenRule">
      <div v-if="activityData && activityData.activityDesc" class="participate-rule">
        <img
          class="rule-img"
          src="@/assets/ticket/rule.png"
          alt=""
        >
        <span class="rule-title">活动说明</span>
      </div>
    </button>
    <img v-if="isInitiator" class="participate-bg" :src="initiateBgPicUrls" alt="">
    <img v-else class="participate-bg" :src="activityData && activityData.picUrls && activityData.picUrls.length && activityData.picUrls[0]" alt="">
    <template v-if="!isInitiator">
      <div class="participate-user" v-if="!isRelated && !isVerifyFinish && (!endStatus)">
        <div class="user-wrapper">
          <van-field type="digit" maxlength="11" placeholder="请输入手机号码" v-model="mobile"></van-field>
        </div>
        <div class="user-wrapper">
          <van-field  type="digit" placeholder="请填写验证码" maxlength="6" v-model="smsCode">
            <template #button>
              <div class="button-warpper">
                <div class="code-action code-action__disabled" v-if="isSmsSend">{{sendBtnText}}</div>
                <div class="code-action" v-else @click="handleSendSmsCode">{{sendBtnText}}</div>
              </div>
            </template>
          </van-field>
        </div>
        <div class="user-action">
          <button class="cnt-button" @click="handleSubmitAction"> 
            <img :src="activityData && activityData.rewardBtnPic" alt="" >
          </button>
        </div>
      </div>
      <div class="activity-accept"
        :style="{
          backgroundImage: `url(${rewardBackgroundPic})`,
        }"
        v-if="!isRelated && isVerifyFinish && isNewRegister">
        <div class="user-action">
          <div class="user-action-open" v-if="rewardBtnPic">
            <openButton buttonTxt="打开/下载舌尖英雄APP" buttonStyle="margin-bottom: 0;" type="participate" point="participate_invitation_accepted_click"></openButton>
          </div>
          <button class="cnt-button"> 
            <img class="user-action-img" :src="rewardBtnPic" >
          </button>
        </div>
      </div>

      <div class="activity-ticket activity-end" v-if="endStatus">
        <img class="dashed-box" src="@/assets/initiate/dashed_box.png" alt="">
        <div class="ticket-title" v-if="status === 3">活动未开始</div>
        <div class="ticket-title" v-if="status === 4 || status === 8">活动已结束</div>
        <div class="ticket-title" v-if="status === 5">活动已失效</div>
        <div class="ticket-desc">去APP查看更多优惠好菜</div>
        <div class="user-action">
          <div class="open-action">打开/下载舌尖英雄APP
            <openButton  buttonTxt="打开/下载舌尖英雄APP" buttonStyle="margin-bottom: 0;" type="participate" point="participate_end_of_activity_click"></openButton>
          </div>
        </div>
      </div>

      <template v-if="status === 1 || status === 2">
        <div class="activity-ticket activity-register" v-if="(isRelated  && !isHasCoupon) || (!isRelated && isVerifyFinish && !isNewRegister && !isHasCoupon)">
          <img class="dashed-box" src="@/assets/initiate/dashed_box.png" alt="">
          <div class="ticket-title">您已是注册用户</div>
          <div class="ticket-desc">更多好菜，尽在舌尖英雄app</div>
          <div class="user-action">
            <div class="open-action">打开/下载舌尖英雄APP
              <openButton buttonTxt="打开/下载舌尖英雄APP" buttonStyle="margin-bottom: 0;" type="participate" point="participate_existing_account_click"></openButton>
            </div>
          </div>
        </div>

        <div class="activity-ticket activity-unused" v-if="(isRelated && isHasCoupon)  || (!isRelated && isVerifyFinish && !isNewRegister  && isHasCoupon)">
          <img class="dashed-box" src="@/assets/initiate/dashed_box.png" alt="">
          <div class="ticket-title">您有{{couponCount}}张优惠券未使用</div>
          <div class="ticket-desc">去舌尖英雄app下单即享优惠</div>
          <div class="user-action">
            <div class="open-action">打开/下载舌尖英雄APP
              <openButton buttonTxt="打开/下载舌尖英雄APP" buttonStyle="margin-bottom: 0;" type="participate" point="participate_n_coupons_unused_click"></openButton>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="activity-footer">
        <div class="footer-action">
          <template  v-if="initiateStatus === 1 || initiateStatus === 2">
            <div class="in-progress" v-if="initiateRecordList && initiateRecordList.length">
              <div class="in-progress-cash">累计获得{{initiateTotalBounty}}元奖励金</div>
              <div class="in-progress-wrapper">
                <img src="@/assets/initiate/wechat_primary.png" alt="">
                <span>邀请更多好友</span>
              </div>
            </div>
            <div class="not-start" v-else>
              <img src="@/assets/initiate/wechat_primary.png" alt="">
              <span>邀请好友</span>
            </div>
          </template>  

          <div class="limit-cnt" v-if="initiateStatus === 3 || initiateStatus === 4 || initiateStatus === 5 || initiateStatus === 8">
            <span class="litmit-text" v-if="initiateStatus === 3">
              活动未开始，去APP查看更多优惠好菜
              <img src="@/assets/initiate/triangle.png" class="triangle" alt="">
            </span>
            <span class="litmit-text" v-if="initiateStatus === 4 || initiateStatus === 8">
              活动已结束，去APP查看更多优惠好菜
              <img src="@/assets/initiate/triangle.png" class="triangle" alt="">
            </span>
            <span class="litmit-text" v-if="initiateStatus === 5">
              活动已失效，去APP查看更多优惠好菜
              <img src="@/assets/initiate/triangle.png" class="triangle" alt="">
            </span>
            <div class="litmit-action">
              <div class="litmit-action-open">
                <span>打开/下载舌尖英雄APP</span>
              </div>
              <OpenButton buttonTxt="打开/下载舌尖英雄APP" buttonStyle="margin-bottom: 0;" type="participate" point="participate_end_of_activity_click"></OpenButton>
            </div>
          </div>  
        </div>
        <div class="footer-img">
          <img :src="initiateProcessImgUrl" alt="">
        </div>
        <Table :recordList="initiateRecordList"></Table>
      </div>
    </template>
  </div>
</template>

<script>
import weixinMixin from '../../mixins/wexin-mixin';
import { isPhone, isSixCode } from '../../utils/validate'
import { getCustomerSmsCode, getCustomerCheckSmsCode, customerActivityFissionInviteeDetail, customerActivityFissionReceiveReward, voucherGetYouzanVoucherNumByMobile, customerActivityFissionInviterDetail,customerActivityFissionShare } from '../../api'
import OpenButton from '@/components/openButton/index.vue'
import wx from 'weixin-js-sdk'
import Table from '@/components/table/index'

export default {
  name: 'Participate',
  mixins: [weixinMixin],
  components: {
    OpenButton,
    Table
  },
  data(){
    return {
      show: true,
      mobile: null,
      smsCode: null,
      sendBtnText: '获取验证码',
      isSmsSend: false,
      counter: 60,
      shareData: null,
      activityData: null,
      activityNo: null,
      fissionCode: null,
      openId: null,
      isVerifyFinish: false,
      isNewRegister: false,
      isInitiator: false,
      isHasCoupon: false,
      isRelated: false,
      couponCount: 0,
      rewardBackgroundPic: null,
      rewardBtnPic: null,
      initiateRecordList: [],
      endStatus: false,
      initiateStatus: null,
      initiateTotalBounty: null,
      isLoading: true,
      inviterMemberId: null,
      initiateBgPicUrls: null,
      status: null,
    }
  },
  methods:{
    async hanglePageInit(openId){
      console.log('mount')
      // oOK4958eUk5LTPtveYK5jxarmLBQ oOK49543gfEY3xFppqXyLNX0AHtA
      this.openId = openId || 'oOK49543gfEY3xFppqXyLNX0AHtA'
      const activityNo = this.$route.query.activityNo;
      const fissionCode = this.$route.query.fissionCode;
      console.log(activityNo)
      if(!activityNo && !fissionCode){
        return this.$toast({ message: 'URL缺少参数'});
      }
      this.activityNo = activityNo
      this.fissionCode = fissionCode
      this.$sensors.track('participate_page_view',{ activityNo: this.activityNo });
      try {
        this.$toast.loading({message: '加载中...',forbidClick: true})
        this.isLoading = true
        await this.customerActivityFissionInviteeDetailRequest()
        this.isLoading = false
      }catch(err){
        this.isLoading = false
      }
    },

    async customerActivityFissionInviteeDetailRequest(){
      const res = await customerActivityFissionInviteeDetail({activityNo:this.activityNo, openid: this.openId, fissionCode: this.fissionCode})
      if (res.code === 200) {
        if(res.busCode === '1'){
          console.log(res.data,'activety')
          document.title =  res.data.title || ''
          this.activityData = res.data
          this.status = res.data.status

          this.inviteeMobile = res.data.inviteeMobile || ''
          this.inviterMemberId =  res.data.inviterMemberId || ''
          this.isRelated = !!this.inviteeMobile

          if(!this.isRelated){
            this.$sensors.track('participate_login_registration_view',{ wxOpenNo: this.openId, activityNo: this.activityNo, activityType: 'yxyl',inviterMemberId: this.inviterMemberId });
          }

          this.handleShareAction(this.activityNo,res.data.inviterMobile,res.data.inviterMemberId)
    
          console.log('请求成功')
          if(this.inviteeMobile){
            this.handleMemeberProcess(this.inviteeMobile)
          }

          if(res.data.status === 3 || res.data.status === 4 || res.data.status === 5 || res.data.status === 8){
            this.endStatus = true
            this.$sensors.track('participate_end_of_activity_view',{activityNo: this.activityNo, activityType: 'yxyl',inviterMemberId: this.inviterMemberId, wxOpenNo: this.openId });
            this.$toast({ message: res.data.message});
          }

          if(res.data.status === 6 || res.data.status === 7){
            this.$toast({ message: res.data.message});
          }
        
        }else{
          this.$toast({ message: res.busMessage});
        }
      } else {
        this.$toast({ message: res.message});
      }
    },

    customerActivityFissionReceiveRewardRequest(telephone){
      this.$toast.loading({message: '加载中...',forbidClick: true})
      customerActivityFissionReceiveReward({activityNo:this.activityNo, mobile:telephone, openid: this.openId, fissionCode: this.fissionCode}).then(res => {
        this.$toast.clear();
        console.log(res)
        if (res.code === 200) {
          if(res.busCode === '1'){
            if(res.data.status === 1){
              this.$sensors.track('participate_login_registration_click',{     });
              this.isVerifyFinish = true;
              this.isNewRegister = true;
              this.$sensors.track('participate_invitation_accepted_view',{ activityNo: this.activityNo, activityType: 'yxyl',inviterMemberId: this.inviterMemberId, wxOpenNo: this.openId });
              this.rewardBackgroundPic = res.data.rewardBackgroundPic;
              this.rewardBtnPic = res.data.rewardBtnPic;
            } else if(res.data.status === 2){
                this.$toast({ message: '您已注册过舌尖英雄App，无法参加此活动'});
                this.isVerifyFinish = true
                this.isNewRegister = false
                this.handleMemeberProcess(this.mobile)
            } else{
              this.$sensors.track('participate_login_registration_click',{ success: 0, activityNo: this.activityNo, activityType: 'yxyl',inviterMemberId: this.inviterMemberId, wxOpenNo: this.openId });
              this.$toast({ message: res.data.message});
            }
          }else{
            this.$sensors.track('participate_login_registration_click',{ success: 0, activityNo: this.activityNo, activityType: 'yxyl',inviterMemberId: this.inviterMemberId, wxOpenNo: this.openId });
            this.$toast({ message: res.busMessage});
          }
        } else {
          this.$sensors.track('participate_login_registration_click',{ success: 0, activityNo: this.activityNo, activityType: 'yxyl',inviterMemberId: this.inviterMemberId, wxOpenNo: this.openId });
          this.$toast({ message: res.message});
        }
      })
    },

    handleMemeberProcess(participatePhone){
      const initiatorPhone = this.activityData.inviterMobile || ''
      console.log(initiatorPhone,'initiatorPhone',participatePhone,'participatePhone')
      if(initiatorPhone === participatePhone){ // 发起人
        this.isInitiator = true
        customerActivityFissionInviterDetail({activityNo:this.activityNo,inviterMobile:initiatorPhone}).then(res => {
          if (res.code === 200) {
            if(res.busCode === '1'){
              this.initiateProcessImgUrl = res.data.processImgUrl
              this.initiateBgPicUrls = res.data.picUrls && res.data.picUrls.length && res.data.picUrls[0]
              this.initiateStatus = res.data.status
              this.initiateTotalBounty = res.data.totalBounty || 0
              this.initiateRecordList =  res.data &&  res.data.inviteeRecordList || []
            }else{
              this.$toast({ message: res.busMessage});
            }
          } else {
            this.$toast({ message: res.message});
          }
        })
      }else{
        this.isInitiator = false
        voucherGetYouzanVoucherNumByMobile({mobile: participatePhone}).then(res => {
          console.log(res)
          if (res.code === 200) {
            if(res.busCode === '1'){
              console.log(res.data)
              this.couponCount = res.data
              if(this.couponCount){ // 有券
                this.$sensors.track('participate_n_coupons_unused_view',{ activityNo: this.activityNo, activityType: 'yxyl',inviterMemberId: this.inviterMemberId, wxOpenNo: this.openId });
                this.isHasCoupon = true
              }else{
                this.$sensors.track('participate_existing_account_view',{ activityNo: this.activityNo, activityType: 'yxyl',inviterMemberId: this.inviterMemberId, wxOpenNo: this.openId });
                this.isHasCoupon = false
              }
            }else{
              this.$toast({ message: res.busMessage});
            }
          } else {
            this.$toast({ message: res.message});
          }
        })
      }
    },

    handleShareAction(activityNo,inviterMobile,inviterMemberId){
      console.log(activityNo,inviterMobile,inviterMemberId,'share')
      if(!inviterMobile || !inviterMemberId){
        return  wx.hideOptionMenu()
      }
      wx.hideOptionMenu()
      wx.showMenuItems({
        menuList: ["menuItem:share:appMessage","menuItem:share:timeline"]
      })
      customerActivityFissionShare({activityNo,inviterMobile,inviterMemberId}).then(res => {
        console.log(res,'share123')
        if (res.code === 200) {
          if(res.busCode === '1'){
            if(res.data.status === 1){
              wx.updateAppMessageShareData({ 
                title: res.data.shareTitle,
                desc: res.data.shareContent,
                link: window.location.href,
                imgUrl: res.data.iconUrl,
                success: function () {
                  console.log('设置朋友成功')
                }
              })
              wx.updateTimelineShareData({ 
                title: res.data.shareTitle,
                link: window.location.href,
                imgUrl: res.data.iconUrl,
                success: function () {
                  console.log('设置朋友圈成功')
                }
              })
            }
          }else{
            this.$toast({ message: res.busMessage});
          }
        } else {
          this.$toast({ message: res.message});
        }

      })

      // }
    },
    handleOpenRule(){
      this.$sensors.track('initiate_participate_activity_description_click');
      this.$modal.show({
        title: '活动说明',
        content: this.activityData && this.activityData.activityDesc,
        closeIcon: true,
        contentStyle: 'text-align:left;'
      });
    },
    handleSubmitAction(){
      if(!this.mobile || !this.mobile.trim()){
        return  this.$toast({ message: '手机号输入不能为空'});
      }
      if(!isPhone(this.mobile)){
        return  this.$toast({ message: '请输入正确的手机号'});
      } 
      if(!this.smsCode || !this.smsCode.trim()){
        return  this.$toast({ message: '验证码不能为空'});
      }
      if(!isSixCode(this.smsCode)){
        return this.$toast({ message: '请输入正确的验证码'});
      }
      getCustomerCheckSmsCode({mobile:this.mobile,smsCode:this.smsCode}).then(res => {
        if (res.code === 200) {
          if(res.busCode === '1'){
            if(res.data){
              this.customerActivityFissionReceiveRewardRequest(this.mobile)
            }else{
              this.$toast({ message: '验证码错误，请重新输入'});
            }
          }else{
            this.$toast({ message: res.busMessage});
          }
        } else {
          this.$toast({ message: res.message});
        }
      })
    },

    handleSendSmsCode(){
      if(!this.mobile || !this.mobile.trim()){
        return this.$toast({ message: '手机号输入不能为空'});
      }
      if(!isPhone(this.mobile)){
        return  this.$toast({ message: '请输入正确的手机号，否则无法接收验证码'});
      } 
      getCustomerSmsCode({mobile:this.mobile}).then(res => {
        if (res.code === 200) {
          if(res.busCode === '1'){
            this.$toast({ message: '验证码已发送'});
            this.isSmsSend = true
            this.handleCountDown()
          }else{
            this.$toast({ message: res.busMessage});
          }
        } else {
          this.$toast({ message: res.message});
        }
      })
    },
    handleCountDown () {
      this.timer = setInterval(() => {
        this.sendBtnText = `${this.counter}s重新获取`
        this.counter--
        if (this.counter < 0) {
          this.handleSmsReset()
        }
      }, 1000)
    },
    handleSmsReset () {
      this.isSmsSend = false
      this.sendBtnText = '获取验证码'
      if (this.timer) {
        clearInterval(this.timer)
        this.counter = 60
        this.timer = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.participate{
  height: 100%;
  position: relative;
  font-family: PingFangSC-Medium, PingFang SC;
  .cnt-button{
    outline: none;
    background: rgba(0,0,0,0);
    border: none;
    font-size: 0;
    padding: 0;
    margin: 0;
  }
  .participate-button{
    outline: none;
    background: rgba(0,0,0,0);
    border: none;
    font-size: 0;
    padding: 0;
    margin: 0;
    .participate-rule{
      position: absolute;
      z-index: 100;
      top: 48px;
      right: 32px;
      width: 164px;
      height: 56px;
      border-radius: 27px;
      background: rgba(1,1,1,0.55);
      font-weight: 500;
      color: #FFFFFF;
      line-height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      .rule-img{
        width: 28px;
        margin-right: 10px;
      }
    }
  }
  .participate-bg{
    font-size: 0;
    width: 100%;
  }

  .participate-user{
    position: absolute;
    left: 40px;
    // bottom: 92px;
    width: 670px;
    top: 1028px;
    min-height: 344px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 32px;
    box-sizing: border-box;
    padding: 24px;
    .user-wrapper{
      margin-bottom: 16px;
      .van-field{
        background: #FFFDFD;
        border-radius: 12px;
        border: 1px solid #CFCFCF;
      }
      .van-cell{
        padding: 14px 0 14px 24px;
      }
      .button-warpper{
        width: 186px;
        display: flex;
        justify-content: center;
        position: relative;
        border-left: 1px solid #E5E5E5;
        .code-line{
          position: absolute;
          left: 0;
          top: 0;
          color: #E5E5E5;;
        }
        .code-action{
          height: 32px;
          font-size: 24px;
          font-weight: 400;
          color: #FF6A39;
          line-height: 32px;
        }
        .code-action__disabled{
          height: 32px;
          font-size: 24px;
          font-weight: 400;
          color: #7D7D7D;
          line-height: 32px
        }
      }
    }
    .user-action{
      padding: 8px 36px 0;
      img{
        width: 100%;
      }
    }
  }

  .activity-accept{
    height: 352px;
    position: absolute;
    background: rgba(255, 255, 255, 0.9);
    // background-image: url(../../assets/test/test1.png) !important;
    background-size: 100% 100%;
    left: 40px;
    // bottom: 92px;
    width: 670px;
    min-height: 344px;
    top: 1028px;
    
    border-radius: 32px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 32px 60px;
    .user-action{
      position: relative;
      .user-action-open{
        position: absolute;
        left: 0;
        right: 0;
        opacity: 0;
      }
      .cnt-button{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .user-action-img{
          max-width: 100%;
          max-height: 0.6rem;
        }
      }

    }
  }

  .activity-ticket{
    text-align: center;
    height: 352px;
    position: absolute;
    left: 40px;
    // bottom: 92px;
    top: 1028px;
    width: 670px;
    min-height: 344px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 32px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .dashed-box{
      width: 642px;
      position: absolute;
      left: 14px;
      top: 14px;
    }
    .ticket-title{
      height: 56px;
      font-size: 40px;
      font-weight: 500;
      color: #111111;
      line-height: 56px;
      margin-top: 60px;
    }
    .ticket-desc{
      height: 40px;
      font-size: 28px;
      font-weight: 400;
      color: #7D7D7D;
      line-height: 40px;
      margin-top: 16px;
    }
    .user-action{
      margin-top: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      .open-action{
        background: #FF6A39;
        width: 550px;
        height: 88px;
        border-radius: 48px;
        font-size: 32px;
        font-weight: 500;
        color: white;
        line-height: 88px;
        text-align: center;
        border: none;
        outline: none;
        position: relative;
        .open-button{
          position: absolute;
          left: 0;
          top: 0;
          opacity: 0;
        }
      }
    }
  }

  .activity-end{
   
  }

  .activity-register{

  }

  .activity-unused{

  }

  .activity-footer{
    position: absolute;
    left: 0;
    right: 0;
    top: 536px;
    padding: 0 20px;
    .footer-action{
      display: flex;
      justify-content: center;
      align-items: center;
      .not-start{
        width: 510px;
        height: 88px;
        background: rgba(255,255,255,0.9);
        color: #FF6A39;
        border-radius: 44px;
        margin-bottom: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 32px;
        font-weight: 500;
        line-height: 40px;
        margin-bottom: 24px;
        img{
          width: 48px;
          margin-right: 4px;
        }
      }
      .in-progress{
        width: 510px;
        height: 112px;
        background: rgba(255,255,255,0.9);
        border-radius: 56px;
        font-weight: 500;
        color: #FF6A39;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-bottom: 24px;
        .in-progress-cash{
          height: 24px;
          font-size: 24px;
          margin-bottom: 8px;
          line-height: 24px;
        }
        .in-progress-wrapper{
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            width: 48px;
            margin-right: 4px;
          }
          span{
            height: 48px;
            font-size: 32px;
            line-height: 48px;

          }
        }
      }
      .end{
        width: 510px;
        height: 88px;
        background: #FFFFFF;
        border-radius: 44px;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #979797;
        line-height: 88px;
        text-align: center;
        margin-bottom: 24px;
      }
      .limit-cnt{
        margin-bottom: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .litmit-text{
          display: inline-block;
          background: rgba(1,1,1,0.55);
          padding: 12px 24px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          border-radius: 8px;
          margin-bottom: 16px;
          position: relative;
          .triangle{
            position: absolute;
            left: 50%;
            bottom: -8px;
            height: 8px;
            transform: translateX(-50%);
          }
        }
        .litmit-action{
          position: relative;
          .litmit-action-open{
            height: 88px;
            width: 562px;
            background: rgba(255,255,255,0.9);
            color: #FF6A39;
            border-radius: 44px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 32px;
            font-weight: 500;
            line-height: 40px;
          }
          .open-button{
            position: absolute;
            z-index: 100;
            left: 0;
            top: 0;
            opacity: 0;
          }
        }

        .litmit{
          width: 510px;
          height: 88px;
          background: #FFFFFF;
          border-radius: 44px;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #979797;
          line-height: 88px;
          text-align: center;
         
        }
      }
    }
    .footer-img{
      margin-bottom: 10px;
      img{
        width: 100%;
      }
    }
    .footer-table{
      height: 420px;
      background: #FFFBF9;
      border-radius: 32px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      .table-header{
        text-align: center;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #111111;
        flex: 0 0 88px;
        .header-item{
          line-height: 88px;
          display: inline-block;
          width: 33%;
          height: 88px;
          background: #F5F6F7;
        }
      }
      .table-main{
        flex: 1;
        overflow-y: auto;
        .table-main-empty{
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          .empty-img{
            width: 200px;
            margin-bottom: 16px;
          }
          .empty-text{
            height: 40px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #969799;
            line-height: 40px;
            text-align: center;
          }
        }
        .table-content{
          text-align: center;
          .content-ul{
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #111111;
            width: 100%;
            height: 120px;
            border-bottom: 1px solid #D8D8D8;
            display: flex;
            .content-item{
              flex: 1;
              font-size: 22px;
              overflow: hidden;
              height: 120px;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
            }
            .content-item-cash{
              color: #FF6A39;
            }
            .content-item-order{  
              font-family: PingFangSC-Regular, PingFang SC;
              line-height: 0;
              .pending-order{ 
                font-size: 24px;
                font-weight: 400;
                color: #979797;
                line-height: 24px;
                margin-bottom: 16px;
              }
              .recommend-order{
                font-size: 22px;
                font-weight: 500;
                color: #FF1600;
                line-height: 22px;
              }
            }
          }
        }
      }
    }
  }


}
</style>
